import React, { Component } from 'react'
import { translate } from 'react-i18next'
import PropTypes from 'prop-types'

import 'styles/mobistyle/mobi.css'
import { formatPercentage, formatPercentageWithoutLimit, isDefined } from '../../utils/masks'
import Mask from 'vanilla-masker'
import Checkbox from '../Checkbox/newCheckbox'
import Button from '../Button'
import { Object } from 'core-js'
import { isEmpty } from 'utils/validations'

const CHECKED = 1
const UNCHECKED = 0
const MAX_LENGTH_PERCENTUAL = 9

class bodyParameters extends Component {
  static propTypes = {
    translate: PropTypes.func,
    submit: PropTypes.func.isRequired,
    allParameters: PropTypes.object.isRequired,
    fieldsDisabled: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      parameters: {
        ...{
          qqChanges: '0',
          qqDay: '0',
          adjustStockSystem: '0',
          valueAdjust: '00,00',
          timoutLatency: '0',
          qqStockLimit: '0',
          valueLimit: '00,00',
          inAVS: 0,
          inTop2500: 0,
          inMDH: 0,
          inPAR: 0,
          inVEF: 0,
        },
        ...this.props.allParameters
      },
      saveDisabled: true,
    }
  }

  componentDidUpdate(prevProps) {
    /* istanbul ignore else */
    if (this.props.allParameters !== prevProps.allParameters) {
      this.atualizarComponente()
    }
  }

  atualizarComponente() {
    if (this.props.allParameters.valueAdjust) {
      this.props.allParameters.valueAdjust = this.moneyMask(
        this.props.allParameters.valueAdjust
      )
    }
    if (this.props.allParameters.valueLimit) {
      this.props.allParameters.valueLimit = this.moneyMask(
        this.props.allParameters.valueLimit
      )
    }
      if(Object.keys(this.props.allParameters).length  > 0) this.setState({ parameters: this.props.allParameters })
    
    if (isEmpty(this.props.allParameters)){
      this.handleReset()
    }
  }

  updateParameters(event, fieldName) {

    const isInvalidChanges =
      fieldName === null ||
      event === null ||
      event.target === null ||
      event.target.value === undefined
    /* istanbul ignore else */
    if (isInvalidChanges) {
      return
    }

    const { parameters } = this.state

    if (['valueAdjust', 'valueLimit'].indexOf(fieldName) !== -1) {
      event.target.value = this.moneyMask(event.target.value.replace(',', ''))
    }

    parameters[fieldName] = event.target.value

    this.setState({ parameters, saveDisabled: false })
  }

  updateParametersCheckbox(value) {
    this.setState((state) => ({
      parameters: {
        ...state.parameters,
        [value]: state.parameters[value] === CHECKED ? UNCHECKED : CHECKED,
      },
      saveDisabled: false,
    }))
  }

  handleReset = () => {
    const {idSPAP} = this.props.allParameters
    this.setState(() => ({
      parameters: {
        idSPAP: idSPAP || null,
        qqChanges: '0',
        qqDay: '0',
        adjustStockSystem: '0',
        valueAdjust: '00,00',
        timoutLatency: '0',
        qqStockLimit: '0',
        valueLimit: '00,00',
        inAVS: 0,
        inTop2500: 0,
        inMDH: 0,
        inPAR: 0,
        inVEF: 0,
      },
      saveDisabled: false,
    }))
  }

  moneyMask = (value) => {
    if (!isDefined(value)) {
      value = '00,00'
    }
    return Mask.toMoney(value.replace(',', ''), { precision: 2 })
  }

  checkedValue = (value) => (value === 1 ? 'checked' : '')

  disableSaveOnSubmit = () => this.setState({saveDisabled: true})

  onSubmit = (parameters) => {
    const {submit} = this.props
    submit(parameters)
    this.disableSaveOnSubmit()
  }

  render() {
    const { translate, fieldsDisabled } = this.props
    const { parameters, saveDisabled } = this.state

    return (
      <div className={'container parameters-per-store-form'}>
        <form className='parametersForm'>
          <span className={'title'}>{translate('mobile.ponctual.title')}</span>
          <div className={'mobiCard'}>
            <table cellPadding='0' cellSpacing='0' className='new-table'>
              <thead>
                <tr>
                  <th scope={'col'} colSpan='1'>
                    Parâmetro
                  </th>
                  <th colSpan='4' className='text-center'>
                    Valores
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className={'mobiItem'}>
                  <td id={'part1'}>
                    {translate('punctual.adjust.parameters.part1')}
                  </td>
                  <td>
                    {' '}
                    <input
                      id={'qqChanges'}
                      placeholder={parameters.qqChanges ? parameters.qqChanges : '0'}
                      maxLength={2}
                      value={parameters.qqChanges}
                      onChange={(event) =>
                        this.updateParameters(event, 'qqChanges')
                      }
                      className='form-control'
                      type='input'
                      disabled={fieldsDisabled} 
                    />{' '}
                  </td>
                  <td className={'label-td'} id={'part2'}>
                    {translate('punctual.adjust.parameters.part2')}
                  </td>
                  <td>
                    {' '}
                    <input
                      id={'qqDay'}
                      placeholder={parameters.qqDay ? parameters.qqDay : '0'}
                      maxLength={2}
                      value={parameters.qqDay}
                      onChange={(event) =>
                        this.updateParameters(event, 'qqDay')
                      }
                      className='form-control'
                      type='input'
                      disabled={fieldsDisabled} 
                    />{' '}
                  </td>
                  <td className={'label-td'} id={'part3'}>
                    {translate('punctual.adjust.parameters.part3')}
                  </td>
                </tr>
                <tr className={'mobiItem'}>
                  <td id={'part4'}>
                    {translate('punctual.adjust.parameters.part4')}
                  </td>
                  <td>
                    {' '}
                    <input
                      id={'adjustStockSystem'}
                      placeholder={parameters.adjustStockSystem ? parameters.adjustStockSystem : '0'}
                      maxLength={MAX_LENGTH_PERCENTUAL}
                      value={formatPercentage(parameters.adjustStockSystem)}
                      onChange={(event) =>
                        this.updateParameters(event, 'adjustStockSystem')
                      }
                      className='form-control'
                      type='input'
                      disabled={fieldsDisabled} 
                    />{' '}
                  </td>
                  <td className={'label-td'} id={'part5'}>
                    {translate('punctual.adjust.parameters.part5')}
                  </td>
                </tr>
                <tr className={'mobiItem'}>
                  <td id={'part6'}>
                    {translate('punctual.adjust.parameters.part6')}
                  </td>
                  <td colSpan={1}>
                    {' '}
                    <input
                      id={'valueAdjust'}
                      maxLength={10}
                      placeholder={parameters.valueAdjust ? parameters.valueAdjust : '0'}
                      value={parameters.valueAdjust}
                      onChange={(event) =>
                        this.updateParameters(event, 'valueAdjust')
                      }
                      className='form-control'
                      type='text'
                      disabled={fieldsDisabled} 
                    />{' '}
                  </td>
                  <td className={'label-td'}>
                    {translate('option.currency.name')}
                  </td>
                  <td colSpan={2}>&nbsp;</td>
                </tr>
                <tr className={'mobiItem'}>
                  <td id={'part7'}>
                    {translate('punctual.adjust.parameters.part7')}
                  </td>
                  <td>
                    {' '}
                    <input
                      id={'timoutLatency'}
                      maxLength={2}
                      placeholder={parameters.timoutLatency ? parameters.timoutLatency : '0'}
                      value={parameters.timoutLatency}
                      onChange={(event) =>
                        this.updateParameters(event, 'timoutLatency')
                      }
                      className='form-control'
                      type='input'
                      disabled={fieldsDisabled} 
                    />{' '}
                  </td>
                  <td className={'label-td'} id={'part8'}>
                    {translate('punctual.adjust.parameters.part8')}
                  </td>
                </tr>
                <tr className={'mobiItem'}>
                  <td id={'part9'}>
                    {translate('punctual.adjust.parameters.part9')}
                  </td>
                  <td>
                    {' '}
                    <input
                      id={'qqStockLimit'}
                      maxLength={MAX_LENGTH_PERCENTUAL}
                      placeholder={parameters.qqStockLimit ? parameters.qqStockLimit : '0'}
                      value={formatPercentageWithoutLimit(parameters.qqStockLimit)}
                      onChange={(event) =>
                        this.updateParameters(event, 'qqStockLimit')
                      }
                      className='form-control'
                      type='input'
                      disabled={fieldsDisabled} 
                    />{' '}
                  </td>
                  <td className={'label-td'} colSpan={3} id={'part5'}>
                    {translate('punctual.adjust.parameters.part5')}
                  </td>
                </tr>
                <tr className={'mobiItem'}>
                  <td id={'part10'}>
                    {translate('punctual.adjust.parameters.part10')}
                  </td>
                  <td>
                    <input
                      id={'valueLimit'}
                      maxLength={10}
                      placeholder={parameters.valueLimit ? parameters.valueLimit : '0'}
                      value={parameters.valueLimit}
                      onChange={(event) =>
                        this.updateParameters(event, 'valueLimit')
                      }
                      className='form-control'
                      type='input'
                      disabled={fieldsDisabled} 
                    />
                  </td>
                  <td className={'label-td'}>
                    {translate('option.currency.name')}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <span className={'title'}>
            {translate('punctual.adjust.parameters.part11')}
          </span>

          <div className={'mobiCard'}>
            <div className='box-check'>
              <div className='form-check box-check-item'>
                <Checkbox
                  onChange={() => this.updateParametersCheckbox('inAVS')}
                  checked={this.checkedValue(parameters.inAVS)}
                  name='inAVS'
                  label={translate('punctual.adjust.parameters.AVS')}
                  disabled={fieldsDisabled} // Desabilitar checkbox
                />
              </div>
              <div className='form-check box-check-item'>
                <Checkbox
                  onChange={() => this.updateParametersCheckbox('inTop2500')}
                  checked={this.checkedValue(parameters.inTop2500)}
                  name='inTop2500'
                  label={translate('punctual.adjust.parameters.Top2500')}
                  disabled={fieldsDisabled} // Desabilitar checkbox
                />
              </div>
              <div className='form-check box-check-item'>
                <Checkbox
                  onChange={() => this.updateParametersCheckbox('inMDH')}
                  checked={this.checkedValue(parameters.inMDH)}
                  name='inMDH'
                  label={translate('punctual.adjust.parameters.MDH')}
                  disabled={fieldsDisabled} // Desabilitar checkbox
                />
              </div>
              <div className='form-check box-check-item'>
                <Checkbox
                  onChange={() => this.updateParametersCheckbox('inPAR')}
                  checked={this.checkedValue(parameters.inPAR)}
                  name='inPAR'
                  label={translate('punctual.adjust.parameters.PAR')}
                  disabled={fieldsDisabled} // Desabilitar checkbox
                />
              </div>
              <div className='form-check box-check-item'>
                <Checkbox
                  onChange={() => this.updateParametersCheckbox('inVEF')}
                  checked={this.checkedValue(parameters.inVEF)}
                  name='inVEF'
                  label={translate('punctual.adjust.parameters.VEF')}
                  disabled={fieldsDisabled} // Desabilitar checkbox
                />
              </div>
            </div>
          </div>
          <div className={'box-btn'}>
            <Button
              role='button'
              type='button'
              className='btn btn-w btn-danger-outline margin-right'
              text={translate('clear_button_label')}
              onClick={this.handleReset}
              disabled={fieldsDisabled} // Desabilitar checkbox
            />
            <Button
              role='button'
              type='button'
              className='btn btn-w btn-primary margin-right'
              disabled={fieldsDisabled || saveDisabled} 
              onClick={() => this.onSubmit(parameters)}
              text={translate('save_button_label')}
            />
          </div>
        </form>
      </div>
    )
  }
}

/* istanbul ignore next */
translate(null, { wait: true, translateFuncName: 'translate' })(bodyParameters)
export default bodyParameters
export { bodyParameters }
